import React from 'react'
import PropTypes from 'prop-types'

import reval from './images/miss_reval.svg'
import mondo from './images/miss_mondo.svg'
import malta from './images/miss_malta.svg'
import ms from './images/ms.svg'
import germany from './images/miss_germany.svg'
import ussr from './images/miss_ussr.svg'
import philippines from './images/miss_philippines.svg'
import helsinki from './images/miss_helsinki.svg'
import universe from './images/miss_universe.svg'

import './styles.css'

const BrandLogos = () => (
  <div className="overflow-hidden">
    <ul className="list mt0 mb6 flex flex-wrap mh--4 items-center justify-center">
      <LogosItem src={reval} />
      <LogosItem src={mondo} />
      <LogosItem src={malta} />
      <LogosItem src={ms} />
      <LogosItem src={germany} />
      <LogosItem src={ussr} />
      <LogosItem src={philippines} />
      <LogosItem src={helsinki} />
      <LogosItem src={universe} />
    </ul>
  </div>
)

const LogosItem = ({ src }) => {
  return (
    <li className="mh4 mb4">
      <img src={src} alt="" />
    </li>
  )
}

BrandLogos.propTypes = {
  children: PropTypes.node
}

export default BrandLogos



// WEBPACK FOOTER //
// ./src/components/brand-logos/brand-logos.js